import { render, staticRenderFns } from "./ListadeProdutosdoPedido.vue?vue&type=template&id=57e1e1d3&scoped=true&"
import script from "./ListadeProdutosdoPedido.vue?vue&type=script&lang=js&"
export * from "./ListadeProdutosdoPedido.vue?vue&type=script&lang=js&"
import style0 from "./ListadeProdutosdoPedido.vue?vue&type=style&index=0&id=57e1e1d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e1e1d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
